<template>
	<div class="projectManage" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<span class="header_text">/ 项目任务 / 项目列表</span>
		</div>
		<div class="content_Box box-shadow" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div  class="p-l-10 p-r-10" style="height: 40px;">
				<div class="fl ">
					<span class="resetBtn m-r-5" @click="resetBtn">全部项目</span>
					<span class="resetBtn m-r-5" @click="projectNew">批量导表</span>
					<span class="resetBtn" @click="projectAbandon">已作废项目</span>
				</div>
				<div class="fr"  >
					<div class="search_box fl" style="">
						<div class="fl s_companyName">
							<el-input v-model="s_companyName" placeholder="项目名称关键词搜索"></el-input>
						</div>
						<div class="fl s_type">
							<el-select v-model="s_type" placeholder="选择状态">
							    <el-option v-for="item in projectTypeArr" :key="item.id" :label="item.name" :value="item.id"> </el-option>
							</el-select>
						</div>
						<div class="fl s_timer">
							<el-date-picker  v-model="s_dateAll"  type="daterange" range-separator="至" @change="dateChange"
							 value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
						<div class="fl s_submit cursor-pointer" @click="shearchBtn">搜索</div>
					</div>
				</div>
				
			</div>
			<template class="">
				<el-table :data="projectArr" stripe style="width: 100%" >
					<el-table-column label="项目编号" width="160px">
						<template slot-scope="{row,$index}">
							<span class=" font-Tahoma ">{{row.project_sn}}</span>
						</template>
					</el-table-column>
					<el-table-column label="项目名称" min-width="160px" :show-overflow-tooltip="true">
						<template slot-scope="{row,$index}">
							<span @click="gotToDetail(row)" class="cursor-pointer text-color-blue font-underline">{{row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="任务" align="right" width="60px">
						<template slot-scope="{row,$index}">
							<span @click="goOrderTask(row)" class="cursor-pointer text-color-blue font-weight-700 font-underline font-Impact">{{row.totality}}</span>
						</template>
					</el-table-column>
					<el-table-column label="订单" align="right" width="60px">
						<template slot-scope="{row,$index}">
							<span v-if=" row.status=='1' " class="cursor-pointer font-underline cz-zf" @click="gotToDetail(row)">支付</span>
							<span v-else-if=" row.status=='2' " class="cursor-pointer font-underline text-color-green" @click="gotToDetail(row)">报审</span>
							<span v-else-if=" row.status=='5' " class="cursor-pointer font-weight-700 font-underline font-Impact text-color-blue" @click="goToOrderList(row)">{{row.totality}}</span>
							<span v-else-if=" row.status=='4' " class="cursor-pointer font-weight-700 font-underline font-Impact text-color-red" @click="goToOrderList(row)">{{row.totality-row.error_order}}</span>
							<span v-else-if=" row.status!='1' && row.status!='4' &&  row.status!='5'">/</span>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态" align="center" width="120px">
						<template slot-scope="{row,$index}">
							<span v-if="row.status=='1'" class="xm-state-1">待支付</span>
							<span v-if="row.status=='2'" class="xm-state-2">待报审</span>
							<span v-if="row.status=='3'" class="xm-state-3">已驳回</span> 
							<span v-if="row.status=='4'" class="xm-state-4">结算{{  100 - (Number(row.error_order) / Number(row.totality) * 100 ).toFixed(2) }}%</span>
							<span v-if="row.status=='5'" class="xm-state-5">已结算</span>
							<span v-if="row.status=='6'" class="xm-state-6">审核中</span>
							<span v-if="row.status=='7'" class="xm-state-7">结算中</span>
							<span v-if="row.status=='8'" class="xm-state-8">已作废</span>
							<span v-if="row.status=='9'" class="xm-state-6">审核中</span>
							<span v-if="row.status=='10'" class="xm-state-10">签约异常</span>
							
						</template>
					</el-table-column>
					<el-table-column prop="settlement_money" align="right" label="项目金额" width="110px">
						<template slot-scope="{row,$index}">
							<p class="font-consolas font-weight-700">{{row.total_money | filterNumber}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="settlement_money" align="right" label="税费服务费" width="110px">
						<template slot-scope="{row,$index}">
							<span class="font-consolas font-weight-700">{{row.rate_money}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="项目时间" align="center" width="170px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.start_time}} ~ {{row.end_time}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bank_card" label="省份城市" width="120px" :show-overflow-tooltip="true">
						<template slot-scope="{row,$index}">
							<span>{{row.district}} - {{row.city}}</span>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" width="140px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.add_time}}</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="150px">
						<template slot-scope="{row,$index}">
							<!-- 待支付 -->
							<div v-if="row.status=='1'">
								<a class="cz-font cz-zf cursor-pointer" @click="gotToDetail(row)">支付</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-js cursor-pointer" :href="url + '/zhongfy/downloadOrderExcel?project_id='+ row.id +'&token='+ token ">结算单</a>	
								<span class="cz-line">|</span>
								<a class="cz-font cz-zuofei cursor-pointer" @click="cancellation(row.id)">作废</a>
							</div>
							<!-- 待报审 -->
							<div v-if="row.status=='2'">
								<a class="cz-font cz-sh cursor-pointer" v-if="row.status=='2'" @click="gotToDetail(row)">提交审核</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-zuofei cursor-pointer" @click="cancellation(row.id)">作废</a>
							</div>
							<!-- 已驳回 -->
							<div v-if="row.status=='3'">
								<a class="cz-font cz-zuofei cursor-pointer" @click="cancellation(row.id)">作废</a>
							</div>
							<!-- 结算异常 -->
							<div v-if="row.status=='4'">
								<a class="cz-font cz-hd cursor-pointer" @click="downLoadHuidan(row.id)">银行回单</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-js cursor-pointer" :href="url + '/zhongfy/downloadOrderExcel?project_id='+ row.id +'&token='+ token " >结算单</a>	
							</div>
							<!-- 已结算 -->
							<div v-if="row.status=='5'">
								<a class="cz-font cz-hd cursor-pointer" @click="downLoadHuidan(row.id)">银行回单</a>
								<span class="cz-line">|</span>
								<a class="cz-font cz-js cursor-pointer" :href="url + '/zhongfy/downloadOrderExcel?project_id='+ row.id +'&token='+ token " >结算单</a>	
							</div>
							<!-- 审核中 -->
							<div v-if="row.status=='6' || row.status=='9'">
								<a class="cz-font cz-js cursor-pointer" :href="url + '/zhongfy/downloadOrderExcel?project_id='+ row.id +'&token='+ token " >结算单</a>	
								<span class="cz-line">|</span>
								<a class="cz-font cz-zuofei cursor-pointer" @click="cancellation(row.id)">作废</a>
							</div>
							<!-- 结算中 -->
							<div v-if="row.status=='7'">
								<a class="cz-font cz-js cursor-pointer" :href="url + '/zhongfy/downloadOrderExcel?project_id='+ row.id +'&token='+ token " >结算单</a>	
							</div>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		mainfun
	} from '../assets/js/main.js';
	export default {
		name: 'projectManage',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				projectArr: [], // 项目集合、
				token: window.sessionStorage.getItem('token'),
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 20, //当前每页多少行
				
				orderSort:'', //状态排序
				s_companyName:'', //搜索企业名称
				s_type:'', //类型
				s_dateAll:'', //项目时间
				startDate:'',
				endDate:'',
				projectTypeArr: [
					{id: '1',name: '待支付'},
					{ id: '2',name: '待报审'},
					{ id: '3',name: '已驳回'},
					{ id: '4', name: '结算异常'},
					{ id: '5', name: '已结算'},
					{ id: '6', name: '审核中'},
					{ id: '7', name: '结算中'}
				],
			}
		},
		created() {
			if (!sessionStorage.getItem('userInfo')) { //判断是否登录
				window.location = 'login.html';
				return;
			}
			let pagingArr = JSON.parse(sessionStorage.getItem('pagingArr')); //分页存储
			if (pagingArr) {
				let paging = pagingArr.filter((val) => {
					return val.name == 'projectManage'
				})
				paging = paging[0]
				if (paging) {
					this.pageNum = paging.pageNum;
					this.pageSizeNow = paging.pageSizeNow;
					this.s_companyName = paging.s_companyName;
					this.s_type = paging.s_type; 
					this.startDate = paging.startDate; 
					this.endDate = paging.endDate; 
					this.s_dateAll = paging.s_dateAll;   //项目时间
					this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
					sessionStorage.removeItem('pagingArr'); //清除分页存储 
				} else {
					this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
				}
			} else {
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			};
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {

			},
			getProjectList() { //获取项目列表
				let fn = new FormData();
				fn.append('page', arguments[0]); //文件
				fn.append('pageSize', arguments[1]); //文件
				fn.append('name', arguments[2]); //项目名称
				fn.append('status', arguments[3]); //状态
				fn.append('start_time', arguments[4]); //开始时间
				fn.append('end_time', arguments[5]); //结束时间
				this.$http.post(this.url + '/zhongfy/company/ProjectList', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						let data = res.data.data;
						this.projectArr = res.data.data.list
						this.total = res.data.data.total
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			// 详情
			gotToDetail(row) {
				let pagingArr = [];
				let paging = {
					name: 'projectManage',
					pageNum: this.pageNum,
					pageSizeNow: this.pageSizeNow,
					s_companyName: this.s_companyName,
					s_type: this.s_type,
					startDate: this.startDate,
					endDate: this.endDate,
					s_dateAll: this.s_dateAll, //项目时间
					
				};
				pagingArr.push(paging);
				sessionStorage.setItem('pagingArr', JSON.stringify(pagingArr)); //分页

				this.$router.push({
					path: '/projectNewDetail',
					query: {
						id: row.id
					}
				})
			},
			// 任务派单
			goOrderTask(row) {
				this.$router.push({
					path: '/orderTask',
					query: {
						pid: row.id
					}
				})
			},
			// 订单
			goToOrderList(row) {
				this.$router.push({
					path: '/orderList',
					query: {
						id: row.id
					},
			
				});
			},
			// 项目作废
			cancellation(id) {
				this.$confirm('您确定要作废这个项目吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fn = new FormData();
					fn.append('p_id', id); //文件
					this.$http.post(this.url + '/zhongfy/company/Cancellation', fn).then((res) => {
						if (res.data.code == '200') {
							this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
						} else if (res.data.code == '8886') { //code   8886  登录过期
							sessionStorage.clear();
							this.$alert('登录已过期，请重新登录 !', '提示', {
								confirmButtonText: '确定',
								callback: action => {
									window.location = 'login.html';
								}
							});
							return;
						} else {
							this.$message.error(res.data.msg);
						}
					}, (res) => {
						this.$message.error('网络错误');
					})
				}).catch(() => {});
			},
			
			dateChange(val) { //时间监听
				if(!val){
					this.startDate = '';
					this.endDate = '';
					return;
				}
				this.startDate = val[0];
				this.endDate = val[1];
			},
			
			// 搜索
			shearchBtn(){
				this.pageNum = 1;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},

			resetBtn() { //重置
				this.pageNum = 1;
				this.s_type = '';
				this.s_dateAll = '';
				this.startDate = '';
				this.endDate = '';
				this.s_companyName = '';
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			
			downLoadHuidan(id) { //导出电子回单
				let loading;
				loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.05)'
				});
				let that = this;
				let token = window.sessionStorage.getItem('token')
				$.ajax({
					url: that.url + '/zhongfy/downloadReceipt?project_id=' + id + '&token=' + token,
					type: 'GET',
					success: function(res) {
						if (res.code == '404') {
							that.$alert('<strong>电子回单银行尚未生成，请完成支付2工作日后再下载。</strong>', '提示', {
								dangerouslyUseHTMLString: true
							});
							loading.close();
							return;
						} else if (res.code == '500') {
							that.$alert('<strong>' + res.msg + '</strong>', '提示', {
								dangerouslyUseHTMLString: true
							});
							loading.close();
							return;
						} else {
							loading.close();
							window.location.href = that.url + '/zhongfy/downloadReceipt?project_id=' + id + '&token=' + token
						}
					},
					error: function(err) {
						loading.close();
						console.log(err);
					},
				});
			},
			
			// 分页
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
			
			// 批量导表，
			projectNew() {
				this.$router.push('/projectNew');
			},
			// 已作废项目， 
			projectAbandon(){
				this.$router.push('/projectAbandon');
				
				// this.s_type = '8';
				// this.getProjectList(this.pageNum, this.pageSizeNow,this.s_companyName,this.s_type,this.startDate,this.endDate);
			},
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.projectManage {}
	.demo-table-expand {font-size: 0;background: #f5f6fa;border: 1px solid #EBEEF5;padding: 15px !important;}
	
</style>



// WEBPACK FOOTER //
// src/components/ProjectManage.vue